module.exports = __webpack_public_path__ + "img/sm-2017-10-01_18-33-44.47ea4de8.jpg";